export default "__VITE_PUBLIC_ASSET__3913deac__"